var map = {
	"./decisions-dark.svg": 90514,
	"./decisions.svg": 50817,
	"./knowledge-dark.svg": 95253,
	"./knowledge.svg": 40968,
	"./quote-dark.svg": 58405,
	"./read-more-dark.svg": 73559,
	"./read-more.svg": 96014,
	"./retention-dark.svg": 82315,
	"./retention.svg": 88970,
	"./save-time-dark.svg": 18060,
	"./save-time.svg": 16215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63764;